import * as S from '@effect/schema/Schema';
import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
var Badge = t.type({
  id: t.string,
  name: t.string,
  imageUrl: t.string,
  description: t.string,
  level: nullable(t.type({
    id: t.string,
    name: t.string,
    rank: t.number
  }))
});
var Member = t.type({
  id: t.string,
  lifetimePoints: t.number,
  level: t.type({
    id: t.string,
    name: t.string
  }),
  earnedBadges: nullable(t.array(t.type({
    badge: Badge,
    earnedDate: nullable(t.string)
  })))
});
export var MemberAchievementsQuery = t.type({
  member: Member
});
var NextLevelProgress = t.type({
  level: t.type({
    id: t.string,
    name: t.string
  }),
  earnedBadgesCount: nullable(t.number),
  requiredBadgesCount: nullable(t.number)
});
var Profile = t.type({
  id: t.string,
  lifetimePoints: t.number,
  level: t.type({
    id: t.string,
    name: t.string
  }),
  nextLevel: nullable(NextLevelProgress)
});
var BadgeProgression = t.type({
  badge: Badge,
  earnedDate: nullable(t.string)
});
export var GetProfileAchievementsQuery = t.type({
  profile: Profile,
  badgeProgressions: t.array(BadgeProgression)
});
export var ProfileAchievementsBlockConfig = S.struct({
  typename: S.literal('ProfileAchievementsBlock'),
  id: S.string,
  hash: S.string,
  memberId: S.string
});